import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { CourseService } from '@scaffold/services/course.service';

@Component({
    selector: 'scaffold-rubric',
    templateUrl: './rubric.component.html',
    styleUrls: ['./rubric.component.scss'],
    standalone: false
})
export class RubricComponent extends BaseScaffoldComponent implements OnInit {
  rubric: any = {};

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private courseService: CourseService
  ) {
    super(cdr, renderedService);
  }
  ngOnInit() {
    if (this.info.id) {
      this.getDataItems(this.info.id).subscribe(rubricData => {
        console.log('rubricData', rubricData);
        this.convertToRubric(rubricData.data);
      });
    }
  }
  convertToRubric(rubricData) {
    console.log('rubricData', rubricData);
    this.rubric.title = rubricData.title;
    this.rubric.description =
      rubricData.description || rubricData.long_descripotion;
    this.rubric.date_created = rubricData.date_created;
    this.rubric.date_modified = rubricData.date_modified;
    this.rubric.rubricType = rubricData.rubricType;
    this.rubric.max_points = rubricData.max_points;

    let columnHeaders = [];
    rubricData.columnHeaders?.forEach(header => {
      columnHeaders[header.position] = header.header;
    });

    this.rubric.criteria = rubricData.criteria.map(criteriaData => {
      console.log(criteriaData);
      let has_description = false;
      let criteria: any = {
        has_description: false,
        description: criteriaData.description,
        percentage: criteriaData.percentage,
        ratings: criteriaData.ratings.map((rating, index) => {
          console.log(rating);
          let title, description, points;

          // Get the title and description for the rating
          if (rating.title?.length > 0) {
            title = rating.title;
          } else if (
            rating.description?.length > 0 &&
            rating.long_description?.length > 0
          ) {
            title = rating.description;
          } else {
            title = columnHeaders[index];
          }
          description = rating.long_description;
          if (
            (!rating.long_description || rating.long_description?.length < 1) &&
            title?.length > 0
          ) {
            description = rating.description;
          }
          if (!title || title?.length < 1) {
            title = rating.description;
          }
          if (description?.length > 0) {
            has_description = true;
          }
          // Get the display points for the rating
          if (this.rubric.rubricType === 'NUMERIC_RANGE') {
            if (rating.start_points === rating.points) {
              points = rating.points;
            } else {
              points = `${rating.start_points} to ${rating.points}`;
            }
          } else if (
            this.rubric.rubricType?.match(/PERCENTAGE/) &&
            rubricData.calcPoints
          ) {
            try {
              points = `${Math.round((Number(rating.points) / Number(rubricData.calcPoints)) * 100 * 100) / 100}%`;
            } catch (e) {
              console.log(e);
              points = rating.points;
            }
          } else if (criteriaData.criterion_use_range) {
            let start;
            if (index === 0 || index === criteriaData.ratings.length - 1) {
              start = null;
            } else {
              start = criteriaData.ratings[index + 1].points;
            }
            if (start !== null) {
              points = `${start} to ${rating.points}`;
            } else {
              points = rating.points;
            }
          } else {
            points = rating.points;
          }
          return {
            points,
            description,
            title,
          };
        }),
      };
      criteria.has_description = has_description;
      return criteria;
    });
    this.update();
  }

  /**
   * @callback getDataItems
   * @param type
   */
  getDataItems(id) {
    this.item.child = undefined;
    let url;
    url = 'courses/' + this.courseService.id + '/rubrics/' + id;
    url +=
      '?output=dataonly&mode=list&key_values=title,description,date_created,date_modified,rubricType,max_points,criteria,calcPoints,columnHeaders';

    return this.courseService.get(url);
  }
}
